module.exports = __webpack_public_path__ + "static/media/profile-pic.47971312.png";